// statusColorMap.ts
export const statusColorMap: Record<string, { background: string; color: string }> = {
    queued: {
      background: "#FFF3CD",  // light amber
      color: "#856404",       // dark amber
    },
    backing_up: {
      background: "#D1ECF1",  // light cyan
      color: "#0C5460",       // dark cyan
    },
    running: {
      background: "rgba(252, 227, 3, 0.3)",  // very light blue
      color: "rgb(252, 198, 3)",       // deep blue
    },
    restoring: {
      background: "#FFE5B4",  // pale orange
      color: "#8A6D3B",       // muted brown/orange
    },
    completed: {
      background: "rgba(71, 237, 52, 0.3)",  // light green
      color: "rgb(39, 181, 36)",       // dark green
    },
    failed: {
      background: "rgba(252, 3, 3, 0.3)",  // light red
      color: "rgb(252, 3, 3)",       // dark red
    },
    timeout: {
      background: "#E2D6F3",  // pale purple
      color: "#512DA8",       // deep purple
    },
    cancelled: {
      background: "#E2E3E5",  // light gray
      color: "#383D41",       // dark gray
    },
  };
  